import type { Adres } from '@/types/domain';
import { adresRegel } from '@/utils/format';

/**
 * Adressen die niet op de kaart horen.
 *
 * De BAG kent alleen objecten en geen projectafspraken. Staat een adres hier,
 * dan valt het uit de kaartlaag: bijvoorbeeld omdat het geen woning blijkt te
 * zijn, al is afgehandeld buiten dit project om, of op verzoek van de
 * gemeente buiten beschouwing blijft.
 *
 * Schrijfwijze zoals op de kaart: straatnaam, spatie, huisnummer. Hoofd- en
 * kleine letters maken niet uit.
 */
export const UITGESLOTEN_ADRESSEN: string[] = [
  'Groenstraat 1',
  'Koningstraat 4',
  'Koningstraat 6',
];

const genormaliseerd = new Set(
  UITGESLOTEN_ADRESSEN.map((adres) => adres.trim().toLowerCase())
);

/** Of dit adres buiten de kaart moet blijven. */
export function isUitgesloten(adres: Adres): boolean {
  return genormaliseerd.has(adresRegel(adres).trim().toLowerCase());
}
